import React from 'react'

import { DirectionType, RenderAnimationType } from './lib/types'
import { TransitionCore } from './core'
import { getOriginByDirection } from './lib/get-origin-by-direction'
import { timingFunc } from '../timing-func'

const getOpacityTimeout = (delay: number | string) => {
	if (!delay) return 100
	let numDelay: number
	if (typeof delay === 'number') numDelay = delay
	else numDelay = parseFloat(delay)

	if (numDelay < 0.1) {
		return numDelay * 1000
	}
	return 100
}

const getTransitionStyles = ({
	direction = 'center',
	delay = 0.5,
	time = 0.5,
	size,
	invertDirection,
}: {
	direction: DirectionType
	delay: string | number
	time: string | number
	size: string | number
	invertDirection?: boolean
}) => {
	const transition = `transform ${time}s ${delay ? delay + 's' : ''} ${
		timingFunc.easeInCubic
	}, opacity ${getOpacityTimeout(delay)}ms linear`
	const transformOrigin = getOriginByDirection(direction, invertDirection)

	return {
		entering: {
			opacity: 1,
			transition,
			transformOrigin,
			transform: 'scale(1)',
		},
		entered: { transform: 'scale(1)', opacity: 1, transformOrigin },
		exiting: {
			transition,
			transformOrigin,
			opacity: 0,
			transform: `scale(${size})`,
		},
		exited: { transform: `scale(${size})`, opacity: 0, transformOrigin },
	}
}

export const renderIncrease: RenderAnimationType =
	({ children, ref, key, className, ...props }) =>
	state =>
		(
			<TransitionCore
				bgColor={'none'}
				className={className}
				key={key}
				ref={ref}
				state={state}
				styles={getTransitionStyles(props)}
			>
				{children}
			</TransitionCore>
		)

export const renderDecrease: RenderAnimationType =
	({ children, ref, className, ...props }) =>
	state =>
		(
			<TransitionCore
				bgColor={'none'}
				className={className}
				ref={ref}
				state={state}
				styles={getTransitionStyles({ ...props, invertDirection: true })}
			>
				{children}
			</TransitionCore>
		)
